import {lazy} from "react";
import { BaseRouter } from "app/model/common/baseRouter";
import { Navigate } from "react-router-dom";
import Layout from "../components/layout/Layout";
const NotPermission = lazy(() => import("app/pages/error/NotPermission"));
const NotFound = lazy(() => import("app/pages/error/NotFound"));
const InvalidAccess = lazy(() => import("app/pages/error/InvalidAccess"));
const SignUpType = lazy(() => import("../pages/signUp/SignUpType"));
const SignUpFormBase = lazy(() => import("app/pages/signUp/SignUpFormBase")) ;

export const publicRouter: BaseRouter[] = [
  { path: "/", element: <Navigate to="/db" replace /> },
  { path: "/logout", element: <Navigate to="/db" replace /> },
  { path: "/sign-up", element: <Layout />,
    children:[
      { path: "/sign-up/type", element: <SignUpType /> },
      { path: "/sign-up/form", element: <SignUpFormBase />}
    ] },
  { path: '/not-permission', element: <NotPermission /> },
  { path: '/err-network', element: <NotFound /> },
  { path: '/invalid-access', element: <InvalidAccess /> },
];
